import './StepCards.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SingleStepCard } from './SingleStepCard/SingleStepCard';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var TABLET_BREAKPOINT = {
  max: 767,
  min: 0
};
var TABLE_PORTRAIT_BREAKPOINT = {
  max: 1282,
  min: TABLET_BREAKPOINT.max + 1
};
var DESKTOP_BREAKPOINT = {
  max: 1482,
  min: TABLE_PORTRAIT_BREAKPOINT.max + 1
};
var EXTRA_BREAKPOINT = {
  max: 10000,
  min: DESKTOP_BREAKPOINT.max + 1
};
var StepsCards = function StepsCards(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var items = get(props.fields, "data.item.cards", []);
  var isList = props.params.variant === "ListVariation";
  var eventsAnalytics = get(props.fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderStepCard = function renderStepCard(item) {
    if (item.stepNumber && item.stepNumber.jss) {
      return /*#__PURE__*/React.createElement(SingleStepCard, {
        key: item.stepNumber.jss.value,
        num: item.stepNumber.jss,
        title: item.title.jss,
        description: item.description.jss,
        link: item.cTALink.jss,
        ctaText: item.ctaLabel.jss,
        onLinkClick: function onLinkClick() {
          return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["readMoreAnalytics"], props.params), [item.title.jss.value, item.ctaLabel.jss.value]);
        }
      });
    } else {
      return null;
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isGreyBackgroundStyle: Boolean(props.params['Is Grey']),
    anchorUrlParameter: props.params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "steps module-group"
  }, items.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "steps__elements ".concat(items.length > 2 ? "steps__elements--3-columns" : "steps__elements--2-columns", " ").concat(isList ? "steps__elements--is-list" : "")
  }, items.map(function (item) {
    return renderStepCard(item);
  })), isList && /*#__PURE__*/React.createElement("div", {
    className: "steps__carousel"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref) {
    var renderDots = _ref.renderDots,
      renderCarousel = _ref.renderCarousel;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(items.map(function (item) {
      return renderStepCard(item);
    }), {
      responsive: {
        extra: {
          breakpoint: EXTRA_BREAKPOINT,
          items: items.length > 4 ? 4 : items.length
        },
        desktop: {
          breakpoint: DESKTOP_BREAKPOINT,
          items: items.length > 3 ? 3 : items.length
        },
        table_portrait: {
          breakpoint: TABLE_PORTRAIT_BREAKPOINT,
          items: items.length > 2 ? 2 : items.length
        },
        tablet: {
          breakpoint: TABLET_BREAKPOINT,
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots())));
  })))));
};
export default StepsCards;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    isGreyBackgroundStyle = _ref2.isGreyBackgroundStyle,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(isGreyBackgroundStyle ? "".concat(commonStyles, "--grey") : "", " ").concat(rtl ? rtlStyles : ltrStyles),
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
var commonStyles = "cv427bd";
var ltrStyles = "l17er0py";
var rtlStyles = "r3ehwxs";